export enum QuickFilter {
  NONE = 'NONE',
  RESET = 'RESET',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_LATE = 'IN_PROGRESS_LATE',
  COMPLETED_LATE = 'COMPLETED_LATE',
  LIKELY_LATE = 'LIKELY_LATE',
  STARTED_TODAY = 'STARTED_TODAY',
  COMPLETED_TODAY = 'COMPLETED_TODAY'
}
